import cx from 'classnames';
import ReactModal from 'react-modal';
import "./Modal.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Modal({
  aside,
  className,
  children,
  overlayClassName,
  size = 'auto',
  ...props
}) {
  return /*#__PURE__*/_jsxs(ReactModal, {
    className: cx('ReactModal__Content', `ReactModal__Content--size-${size}`, className),
    closeTimeoutMS: 1000,
    overlayClassName: cx('ReactModal__Overlay', overlayClassName),
    ...props,
    "data-sentry-element": "ReactModal",
    "data-sentry-component": "Modal",
    "data-sentry-source-file": "Modal.tsx",
    children: [/*#__PURE__*/_jsx("div", {
      className: "ReactModal__main",
      children: children
    }), aside && /*#__PURE__*/_jsx("div", {
      className: "ReactModal__aside",
      children: aside
    })]
  });
}